export default "__VITE_ASSET__CIekCb5h__"